module.exports = __webpack_public_path__ + "static/media/banner.98e22cad.jpg";